module.exports = __webpack_public_path__ + "static/media/view section.86cf2cfe.svg";